import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSignupWorkEnvironmentFilter } from './useSignupWorkEnvironmentFilter';

export const SignupWorkEnvironmentFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, workEnvironmentOptions } = useSignupWorkEnvironmentFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ signupWorkEnvironments: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="signupWorkEnvironments"
          label="Work environment"
          placeholder="Add..."
          size="small"
          component={FormMultiSelect}
          options={workEnvironmentOptions}
          anchorToBody
          isSearchable={false}
        />
      </Form>
    </Formik>
  );
};

SignupWorkEnvironmentFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

SignupWorkEnvironmentFilter.defaultProps = {
  value: [],
};
